import { P2Alert } from "react-bootstrap-common-script";
interface ReviewingPageProps{
  message:string
}
function ReviewingPage({...props}:ReviewingPageProps) {
  return (
    <div className="polymer-stage-d-container__reviewing">
      <P2Alert variant={"warning"} text={props.message}/>
    </div>
  );
}

export default ReviewingPage;
